<div>
   <div class="row">
        <div class="col-md-12">
            <div class="card-box">
                <div v-show="!loading">
                    <data-table :headings="transactionHistoryHeadings" :data="transactionHistory" :hasActions="false"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @filterSearchClicked="onFilterSearchClicked">
                        <template #filter>
                            <div class="input-group pb-4">
                                <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                            <from-date-to-date-pickers  :title="'Date Created'"
                                                        :fromDate="filter.fromDateCreated"
                                                        :toDate="filter.toDateCreated"
                                                        :elementId="'customerDateFilter'"
                                                        :dateFormat="'DD/MM/YYYY'"
                                                        @clearDatePicker="onDateFilterClearClick"
                                                        @fromDateSelected="onFromDateCreatedSelect"
                                                        @toDateSelected="onToDateCreatedSelect"></from-date-to-date-pickers>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
   </div>
</div>
